module.exports = __webpack_public_path__ + "static/media/ajai.bd6cc634.jpeg";